export default __webpack_public_path__ + "static/media/settings.ce7a8e5d.png";